var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5080_88764)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5080_88764)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 0H6C2.68629 0 0 2.68629 0 6V42C0 45.3137 2.68629 48 6 48H74C77.3137 48 80 45.3137 80 42V6C80 2.68629 77.3137 0 74 0Z",
    fill: "#F6F8FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5080_88764",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 9,
    width: 49,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 9H16V47H65V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5080_88764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.129 35.9663H33.8779V12.2285H47.1292L47.129 35.9663Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.718 24.0967C34.718 19.2815 36.9798 14.9921 40.502 12.2278C37.8359 10.1323 34.5384 8.99501 31.1432 9.00002C22.7796 9.00002 16 15.759 16 24.0967C16 32.4345 22.7796 39.1934 31.1432 39.1934C34.5385 39.1985 37.8361 38.0612 40.5022 35.9656C36.9803 33.2018 34.718 28.9122 34.718 24.0967Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0063 24.0967C65.0063 32.4345 58.2267 39.1934 49.8631 39.1934C46.4675 39.1984 43.1695 38.0611 40.5029 35.9656C44.026 33.2013 46.2878 28.9121 46.2878 24.0967C46.2878 19.2813 44.026 14.9921 40.5029 12.2278C43.1695 10.1324 46.4673 8.9951 49.8629 9.00002C58.2265 9.00002 65.0063 15.7589 65.0063 24.0967Z",
    fill: "#F79E1B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5080_88764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5080_88764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMasterCard);
export default __webpack_public_path__ + "static/media/ic-master-card.22494794e710b6fb649a4471bf8b07a4.svg";
export { ForwardRef as ReactComponent };